import { useTranslation } from 'react-i18next';
import { Control, Path } from 'react-hook-form';

import { Stack } from '@mui/material';

import Typography from '../../../../../../../../../components/Typography';
import { AttendanceData } from '../../../../../../../../../db/classes/types';
import { i18nNS } from '../../../../../../../../../i18n';
import ClassList from '../ClassList';
import { FormValues } from '../types';

export interface NextScheduledAttendanceProps<T extends FormValues> {
  nextScheduledAttendanceData: AttendanceData['nextScheduled'];
  control: Control<T>;
  name: Path<T>;
}

const NextScheduledAttendance = <T extends FormValues>({
  nextScheduledAttendanceData,
  control,
  name,
}: NextScheduledAttendanceProps<T>) => {
  const { t } = useTranslation([i18nNS.SHARED, i18nNS.CLASS]);

  return (
    <Stack gap={2}>
      <Typography variant="paragraphBold" component="h3">
        {t('no_lectures_are_in_session_right_now', {
          ns: i18nNS.CLASS,
        })}
      </Typography>
      <Typography variant="paragraphRegular">
        {t(
          'acadly_cannot_find_any_scheduled_lectures_in_your_course_that_are_in_session_right_now_whenever_attendance_is_being_recorded_during_a_scheduled_lecture_you_will_be_able_to_proceed_by_selecting_the_appropriate_lecture',
          {
            ns: i18nNS.CLASS,
          }
        )}
      </Typography>
      {nextScheduledAttendanceData.length !== 0 && (
        <Typography variant="paragraphBold" color="grey.600">
          {t('next_lecture_in_which_attendance_can_be_recorded', {
            ns: i18nNS.CLASS,
          })}
        </Typography>
      )}

      {nextScheduledAttendanceData.map(({ courseData, classData }) => {
        return (
          <Stack gap={2}>
            <Typography
              variant="paragraphBold"
              color="grey.600"
              px={2}
              pb={1}
              position="sticky"
              top={0}
              zIndex={1}
              bgcolor="white"
            >
              {t('course_code_colon_course_title', {
                ns: i18nNS.SHARED,
                courseCode: courseData.code,
                courseTitle: courseData.title,
              })}
            </Typography>
            <ClassList control={control} name={name} isLoading={false} classList={classData} disabledOption />
          </Stack>
        );
      })}
    </Stack>
  );
};

export default NextScheduledAttendance;
